const commoncomponent = {
  fourZeroFour: {
    url: "/404",
    metaTitle: "404 - Page Not Found | Vessel Inspection Portal",
    metaDescription:
      "The page you are looking for does not exist or has been moved. Please check the URL or return to the dashboard."
  },
  help: {
    url: "/help",
    metaTitle: "Help & Support | Vessel Inspection Portal",
    metaDescription:
      "Get help, FAQs, and support for managing your vessels, crew, and inspections efficiently."
  },

  logout: {
    url: "/logout",
    metaTitle: "Logout | Vessel Inspection Portal",
    metaDescription:
      "Safely log out of your account to end your session and protect your data."
  },
};

const nonAuthedcomponent = {
  login: {
    url: "/login",
    metaTitle: "Login | Vessel Inspection Portal",
    metaDescription:
      "Log in securely to access your vessel inspection and management dashboard."
  },
  forgetPin: {
    url: "/forget-pin",
    metaTitle: "Forgot PIN | Account Security — Vessel Inspection Portal",
    metaDescription:
      "Reset your account PIN securely. Follow the verification and verification code steps to create a new PIN and protect your account access.",

  },
  resetPin: {
    url: "/reset-pin",
    metaTitle: "Reset PIN | Account Security — Vessel Inspection Portal",
    metaDescription:
      "Reset your account PIN securely. Follow the verification and verification code steps to create a new PIN and protect your account access.",

  },

  setPin: {
    url: "/set-pin",
    metaTitle: "Set Security PIN | Vessel Inspection Portal",
    metaDescription:
      "Set up your security PIN for quick and safe access to your inspection system account."
  },
  ssoCallback: {
    url: "/sso-callback",
    metaTitle: "SSO Sign In | Vessel Inspection Portal",
    metaDescription: "Completing single sign-on to your iSHIP account.",
  },
  lockScreen: {
    url: "/lock",
    metaTitle: "Screen Locked | Vessel Inspection Portal",
    metaDescription:
      "Your session is locked for security reasons. Please unlock using your PIN or password."
  }
};

const Authedcomponent = {
  dashboard: {
    url: "/",
    metaTitle: "Admin Dashboard | Vessel Inspection Portal",
    metaDescription:
      "Monitor vessel operations, crew activities, compliance reports, and system analytics from your admin dashboard."
  },
  crewDashboard: {
    url: "/crew",
    metaTitle: "Crew Dashboard | Vessel Inspection Portal",
    metaDescription:
      "Access your crew dashboard to view assigned vessels, tasks, and inspection updates."
  },
  fleetMap: {
    url: "/fleet-map",
    metaTitle: "Fleet Map | Vessel Inspection Portal",
    metaDescription:
      "Live satellite view of real-time fleet vessel positions."
  },


  profile: {
    url: "/profile",
    metaTitle: "My Profile | Vessel Inspection Portal",
    metaDescription:
      "View and manage your personal profile, credentials, and account settings."
  },
  editProfile: {
    url: "/profile/edit",
    metaTitle: "Edit Profile | Vessel Inspection Portal",
    metaDescription:
      "Edit your profile details, upload a new photo, or update your contact information."
  },

  // 👩‍✈️ Crew Management
  listCrew: {
    url: "/crew/list",
    metaTitle: "Crew Directory | Vessel Inspection Portal",
    metaDescription:
      "Browse the complete list of crew members assigned to vessels and manage their profiles."
  },
  crewProfile: {
    url: "/crew/profile",
    metaTitle: "Crew Profile | Vessel Inspection Portal",
    metaDescription:
      "View detailed information, documents, and voyage history of a specific crew member."
  },

  // 🧭 Vessel Owner
  addVesselOwner: {
    url: "/vessel/owner/add",
    metaTitle: "Add Vessel Owner | Vessel Inspection Portal",
    metaDescription:
      "Register a new vessel owner with company details, contact info, and ownership remarks."
  },
  editVesselOwner: {
    url: "/vessel/owner/edit",
    metaTitle: "Edit Vessel Owner | Vessel Inspection Portal",
    metaDescription:
      "Edit existing vessel owner information, including address and remarks."
  },
  listVesselOwner: {
    url: "/vessel/owner/list",
    metaTitle: "Vessel Owners | Vessel Inspection Portal",
    metaDescription:
      "Manage and view all registered vessel owners in the system with contact and ownership data."
  },

  // ⚓ Vessel Group
  addVesselGroup: {
    url: "/vessel/group/add",
    metaTitle: "Add Vessel Group | Vessel Inspection Portal",
    metaDescription:
      "Create a new vessel group to organize fleets for easy tracking and management."
  },
  editVesselGroup: {
    url: "/vessel/group/edit",
    metaTitle: "Edit Vessel Group | Vessel Inspection Portal",
    metaDescription:
      "Modify an existing vessel group’s name or description for accurate grouping."
  },
  listVesselGroup: {
    url: "/vessel/group/list",
    metaTitle: "Vessel Groups | Vessel Inspection Portal",
    metaDescription:
      "View and manage all vessel groups categorized under your organization."
  },

  assignVesselGroup: {
    url: "/vessel/group/assign",
    metaTitle: "Assign Vessel Group | Vessel Inspection Portal",
    metaDescription:
      "Assign vessel group to organize fleets for easy tracking and management."
  },
  assignVesselGroupToCrew: {
    url: "/crew/group/assign",
    metaTitle: "Assign Users to Vessel Group | Vessel Inspection Portal",
    metaDescription:
      "Assign superintendents and crew to a vessel group so they only manage vessels in that fleet."
  },
  // ⚙️ Role Management
  addRole: {
    url: "/role/add",
    metaTitle: "Add Role | Vessel Inspection Portal",
    metaDescription:
      "Create a new user role and assign permissions for better access control."
  },
  editRole: {
    url: "/role/edit",
    metaTitle: "Edit Role | Vessel Inspection Portal",
    metaDescription:
      "Edit role names, permissions, and access levels for platform users."
  },
  listRole: {
    url: "/role/list",
    metaTitle: "Role Management | Vessel Inspection Portal",
    metaDescription:
      "View all roles and their associated permissions for users within the system."
  },

  // 🧑‍🔧 Designation
  addDesignation: {
    url: "/designation/add",
    metaTitle: "Add Designation | Vessel Inspection Portal",
    metaDescription:
      "Add new designations such as Captain, Engineer, or Superintendent for crew records."
  },
  editDesignation: {
    url: "/designation/edit",
    metaTitle: "Edit Designation | Vessel Inspection Portal",
    metaDescription:
      "Update job titles or roles used across the platform for crew or staff."
  },
  listDesignation: {
    url: "/designation/list",
    metaTitle: "Designation Directory | Vessel Inspection Portal",
    metaDescription:
      "View and manage all existing job designations in the master list."
  },

  // 🏢 Department
  addDepartment: {
    url: "/department/add",
    metaTitle: "Add Department | Vessel Inspection Portal",
    metaDescription:
      "Create a new department like Engine, Deck, or Catering to classify crew assignments."
  },
  editDepartment: {
    url: "/department/edit",
    metaTitle: "Edit Department | Vessel Inspection Portal",
    metaDescription:
      "Edit department names and update departmental responsibilities."
  },
  listDepartment: {
    url: "/department/list",
    metaTitle: "Department List | Vessel Inspection Portal",
    metaDescription:
      "Manage the list of company departments and crew allocations."
  },

  // 📄 Crew Document Type
  addCrewDocumentType: {
    url: "/crew-document-type/add",
    metaTitle: "Add Crew Document Type | Vessel Inspection Portal",
    metaDescription:
      "Define a new document type required for crew verification or compliance."
  },
  editCrewDocumentType: {
    url: "/crew-document-type/edit",
    metaTitle: "Edit Crew Document Type | Vessel Inspection Portal",
    metaDescription:
      "Edit document type names and requirements for crew compliance."
  },
  listCrewDocumentType: {
    url: "/crew-document-type/list",
    metaTitle: "Crew Document Types | Vessel Inspection Portal",
    metaDescription:
      "View and manage all document types required for crew certification and onboarding."
  },

  // 🗂️ Crew Document Category
  addCrewDocumentCategory: {
    url: "/crew-document/category/add",
    metaTitle: "Add Document Category | Vessel Inspection Portal",
    metaDescription:
      "Create a new document category for better classification of crew documents."
  },
  editCrewDocumentCategory: {
    url: "/crew-document/category/edit",
    metaTitle: "Edit Document Category | Vessel Inspection Portal",
    metaDescription:
      "Modify existing document categories for structured document management."
  },
  listCrewDocumentCategory: {
    url: "/crew-document/category/list",
    metaTitle: "Document Categories | Vessel Inspection Portal",
    metaDescription:
      "View and manage all crew document categories used in the inspection system."
  },

  // 🎓 Qualification Master
  addQualiticationMaster: {
    url: "/qualification/add",
    metaTitle: "Add Qualification | Vessel Inspection Portal",
    metaDescription:
      "Add a new qualification for crew such as STCW or marine certifications."
  },
  editQualiticationMaster: {
    url: "/qualification/edit",
    metaTitle: "Edit Qualification | Vessel Inspection Portal",
    metaDescription:
      "Update qualification details to keep crew records accurate and up to date."
  },
  listQualiticationMaster: {
    url: "/qualification/list",
    metaTitle: "Qualification List | Vessel Inspection Portal",
    metaDescription:
      "View and manage all qualifications available for crew verification."
  },

  // 🧰 Experience Type
  addExperienceType: {
    url: "/experience-type/add",
    metaTitle: "Add Experience Type | Vessel Inspection Portal",
    metaDescription:
      "Define a new experience type such as Sea Experience or Engine Room Experience."
  },
  editExperienceType: {
    url: "/experience-type/edit",
    metaTitle: "Edit Experience Type | Vessel Inspection Portal",
    metaDescription:
      "Edit or update crew experience types to improve profile categorization."
  },
  listExperienceType: {
    url: "/experience-type/list",
    metaTitle: "Experience Types | Vessel Inspection Portal",
    metaDescription:
      "Browse and manage all experience types applicable for crew history records."
  },

  // 👥 User Management
  addUser: {
    url: "/user/add",
    metaTitle: "Add User | Vessel Inspection Portal",
    metaDescription:
      "Add a new system user and assign a role with specific access permissions."
  },
  editUser: {
    url: "/user/edit",
    metaTitle: "Edit User | Vessel Inspection Portal",
    metaDescription:
      "Edit existing user details and modify access levels or role assignments."
  },
  listUser: {
    url: "/user/list",
    metaTitle: "User List | Vessel Inspection Portal",
    metaDescription:
      "View all users with search, role filter, and activity tracking options."
  },
  // 🚢 Vessel Management
  addVessel: {
    url: "/vessel/add",
    metaTitle: "Add Vessel | Vessel Inspection Portal",
    metaDescription:
      "Register a new vessel with IMO number, ship type, ownership, and operational details."
  },
  vesselOnboard: {
    url: "/vessel/onboard",
    metaTitle: "Vessel Onboarding | Complete Vessel Form",
    metaDescription:
      "Redirects to the full vessel onboarding form — particulars, engines, machinery by section, drydock, and more.",
  },
  editVessel: {
    url: "/vessel/edit",
    metaTitle: "Edit Vessel | Vessel Inspection Portal",
    metaDescription:
      "Update vessel information, ownership details, and inspection records."
  },
  listVessel: {
    url: "/vessel/list",
    metaTitle: "Vessel Directory | Vessel Inspection Portal",
    metaDescription:
      "View the list of all vessels with filters for owner, status, and ship type."
  },
  vesselInfo: {
    url: "/vessel/info",
    metaTitle: "Vessel Info | Log Abstracts & Reports",
    metaDescription:
      "OVD-style vessel data — log abstracts, bunker reports, electricity, commercial periods, and voyage detail."
  },
  previewVessel: {
    url: "/vessel/preview",
    metaTitle: "Vessel Details | Vessel Inspection Portal",
    metaDescription:
      "Preview vessel details including specifications, inspection reports, and history."
  },
  vesselMachinery: {
    url: "/vessel/machinery",
    metaTitle: "Vessel Machinery Tree | Vessel Inspection Portal",
    metaDescription:
      "Complete vessel component tree and mind map — systems, equipment, parts, part numbers, and serials.",
  },
  vesselDashboard: {
    url: "/vessel/dashboard",
    metaTitle: "Vessel Dashboard | Vessel Inspection Portal",
    metaDescription:
      "View a complete overview of vessel details including specifications, inspection status, compliance reports, and operational history."
  },


  // 🚀 Ship Type
  addShipType: {
    url: "/vessel/ship-type/add",
    metaTitle: "Add Ship Type | Vessel Inspection Portal",
    metaDescription:
      "Add a new ship type such as Cargo, Tanker, or Passenger to the master list."
  },
  editShipType: {
    url: "/vessel/ship-type/edit",
    metaTitle: "Edit Ship Type | Vessel Inspection Portal",
    metaDescription:
      "Edit or rename ship types used for vessel categorization."
  },
  listShipType: {
    url: "/vessel/ship-type/list",
    metaTitle: "Ship Types | Vessel Inspection Portal",
    metaDescription:
      "Browse and manage all registered ship types for vessel classification."
  },

  // 🛳️ Ship Purpose
  addShipPurpose: {
    url: "/vessel/ship-purpose/add",
    metaTitle: "Add Ship Purpose | Vessel Inspection Portal",
    metaDescription:
      "Add a new ship purpose such as Commercial, Training, or Research vessel."
  },
  editShipPurpose: {
    url: "/vessel/ship-purpose/edit",
    metaTitle: "Edit Ship Purpose | Vessel Inspection Portal",
    metaDescription:
      "Edit ship purpose definitions for accurate fleet tracking and reporting."
  },
  listShipPurpose: {
    url: "/vessel/ship-purpose/list",
    metaTitle: "Ship Purposes | Vessel Inspection Portal",
    metaDescription:
      "View and manage all ship purposes used for vessel classification."
  },

  // 🛢️ MARPOL Master Data
  marpolMasterList: {
    url: "/marpol-master/list",
    metaTitle: "MARPOL Master Data | Vessel Inspection Portal",
    metaDescription:
      "Manage every selectable dropdown used across MARPOL record books (Tank Type, Oil Type, Equipment, Fuel Type, etc.)."
  },
  marpolMasterAdd: {
    url: "/marpol-master/add",
    metaTitle: "Add MARPOL Master Entry | Vessel Inspection Portal",
    metaDescription:
      "Add a new option that will appear in MARPOL record book dropdowns."
  },
  marpolMasterEdit: {
    url: "/marpol-master/edit",
    metaTitle: "Edit MARPOL Master Entry | Vessel Inspection Portal",
    metaDescription:
      "Edit an existing MARPOL master data option."
  },
  marpolMasterCategory: {
    url: "/marpol-master/category",
    metaTitle: "MARPOL Master Category | Vessel Inspection Portal",
    metaDescription:
      "Browse and manage all entries inside a single MARPOL master category."
  },

  listRBAC: {
    url: "/settings/role/permission",
    metaTitle: "RBAC | Role-Based Access Control",
    metaDescription:
      "Manage roles, permissions, and access control settings for the system."
  },
  accessControl: {
    url: "/access-control",
    metaTitle: "Access Control | Rank-Wise Module Permissions",
    metaDescription:
      "Define which modules and sub-modules each rank (role) can view, create, edit, delete and approve.",
    sections: {
      roles: "/access-control?section=roles",
      departments: "/access-control?section=departments",
      designations: "/access-control?section=designations",
      permissions: "/access-control?section=permissions",
    },
  },
  systemConfig: {
    url: "/settings/system-config",
    metaTitle: "System Config | Application Settings",
    metaDescription:
      "Configure display preferences, default list sizes, and operational settings for your organisation."
  },
  nearMissConfig: {
    url: "/settings/near-miss-config",
    metaTitle: "Near Miss Config | Safety Module Settings",
    metaDescription:
      "Configure near miss categories, severity matrix, escalation rules, and email alerts."
  },
  permitTemplates: {
    url: "/permits",
    metaTitle: "Permits | Template Library",
    metaDescription:
      "Create and publish permit-to-work templates used by vessel Master, C/O, and C/E. Superintendent reviews with digital sign."
  },
  masterFormula: {
    url: "/settings/master-formula",
    metaTitle: "Master Formula | Environment Calculations",
    metaDescription:
      "Manage environment tab column labels and calculation formulas for CII, EEOI, NOx, SOx, FuelEU, and EU-ETS."
  },
  notifications: {
    url: "/settings/notifications",
    metaTitle: "Notifications | Alert Preferences",
    metaDescription:
      "Manage email and in-app notification preferences for reports, approvals, and system alerts."
  },
  notificationsCenter: {
    url: "/notifications",
    metaTitle: "Notifications | In-App Alerts & Approvals",
    metaDescription:
      "View all pending approvals, report submissions, MARPOL sign-offs, and recent platform activity."
  },
  ssoSettings: {
    url: "/settings/sso",
    metaTitle: "SSO & Identity | Login Providers",
    metaDescription:
      "Configure Microsoft Entra ID, Google Workspace, Okta, and other OIDC identity providers for organisation login."
  },
  aiSkillsSettings: {
    url: "/settings/ai-skills",
    metaTitle: "Agent Studio | iShip Intelligence",
    metaDescription:
      "Create governed AI agents and reusable skills, then connect them to operational modules."
  },
  createTicket: {
    url: "/settings/support/ticket",
    metaTitle: "Create Support Ticket | Help & Assistance",
    metaDescription:
      "Submit a support ticket for technical issues, feature requests, or general assistance. Our team will review and respond promptly."
  },
  ticketList: {
    url: "/settings/support/ticket/list",
    metaTitle: "Support Ticket List | View & Manage Requests",
    metaDescription:
      "Browse, filter, and manage support tickets submitted by users. Track issue status, priority, and history in one centralized dashboard."
  },
  editTicket: {
    url: "/settings/support/ticket/edit",
    metaTitle: "Update Support Ticket | Modify or Review Ticket Details",
    metaDescription:
      "Review and update support ticket details including status, priority, and responses. Keep support requests organized and up to date."
  },

  vesselWall: {
    url: "/vessel/wall",
    metaTitle: "Vessel Wall | Vessel Activity & Operational Timeline",
    metaDescription:
      "View real-time vessel activity, historical logs, status updates, and operational insights in a consolidated vessel wall timeline."
  },
  engineLogCreate: {
    url: "/report/engine-log",
    metaTitle: "Engine Log | Vessel Daily Performance Summary",
    metaDescription:
      "Create and review engine log entries with main engine, auxiliary engines, fuel consumption, and performance data."
  },

  noonReportCreate: {
    url: "/report/noon-report",
    metaTitle: "Noon Report | Daily Vessel Position & Weather",
    metaDescription:
      "File the daily noon report with vessel position, speed, weather, and operational status."
  },

  noonReportList: {
    url: "/report/noon-report/list",
    metaTitle: "Noon Report List | Daily Vessel Position & Weather",
    metaDescription:
      "Browse noon reports including vessel position, weather updates, fuel usage details, and voyage performance records."
  },

  engineLogList: {
    url: "/report/engine-log/list",
    metaTitle: "Engine Log List | Vessel Daily Performance Summary",
    metaDescription:
      "Browse engine log entries including fuel usage, engine performance, and operational status."
  },

  noonReportPreview: {
    url: "/report/noon-report/preview",
    metaTitle: "Noon Report Preview | Daily Vessel Position & Weather",
    metaDescription:
      "Preview detailed noon report data including vessel navigation status, speed, weather, fuel consumption, and performance metrics."
  },

  engineLogPreview: {
    url: "/report/engine-log/preview",
    metaTitle: "Engine Log Preview | Vessel Daily Performance Summary",
    metaDescription:
      "Preview detailed engine log data including main engine parameters, auxiliary engines, fuel consumption, and running hours."
  },

  noonReportReport: {
    url: "/report/engine-log/report",
    metaTitle: "Engine Log Report | Daily Vessel Performance & Fuel Summary",
    metaDescription:
      "View and verify the vessel engine log with detailed performance, fuel and oil consumption, and operational remarks."
  },


  deckLog: {
    url: "/report/deck-log",
    metaTitle: "Deck Log | Daily Vessel Operations Log",
    metaDescription:
      "Record and review daily deck log entries including navigation details, weather conditions, watch activities, and operational remarks."
  },

  deckLogList: {
    url: "/report/deck-log/list",
    metaTitle: "Deck Log List | Daily Vessel Operations Log",
    metaDescription:
      "View all recorded deck log entries with navigation data, weather reports, watch activities, and operational notes."
  },

  deckLogPreview: {
    url: "/report/deck-log/preview",
    metaTitle: "Deck Log Preview | Daily Vessel Operations Log",
    metaDescription:
      "Preview detailed deck log entries including navigation information, environmental conditions, watch duties, and operational remarks."
  },

  deckLogCompare: {
    url: "/report/deck-log/compare",
    metaTitle: "Deck Log Compare | Side-by-side Daily Reports",
    metaDescription:
      "Compare deck log noon reports side-by-side across dates — position, fuel, weather, and performance fields."
  },

  deckLogReport: {
    url: "/report/deck-log/report",
    metaTitle: "Deck Log Report Preview | Daily Vessel Navigation & Operations",
    metaDescription:
      "Review daily deck log records including vessel position, navigation details, weather and sea conditions, watchkeeping activities, and operational remarks."
  },


  mainEnginePerformaceReportCreate: {
    url: "/report/main-engine-performance/create",
    metaTitle: "Noon Report | Vessel Daily Performance Summary",
    metaDescription:
      "Create and review noon reports with vessel position, speed, weather conditions, fuel consumption, and engine performance data."
  },


  oconDGRunningHoursReportCreate: {
    url: "/report/ocon-dg-running-hours/create",
    metaTitle: "Noon Report | Vessel Daily Performance Summary",
    metaDescription:
      "Create and review noon reports with vessel position, speed, weather conditions, fuel consumption, and engine performance data."
  },

  oconDGRunningHoursReportList: {
    url: "/report/ocon-dg-running-hours/list",
    metaTitle: "Operational Report | Vessel Daily Performance Summary",
    metaDescription:
      "Review submitted OCON DG running-hours and weekly emergency generator running-test records."
  },

  operationReportSubmissionList: {
    url: "/report/operation-submission/list",
    metaTitle: "Operational Report | Vessel Daily Performance Summary",
    metaDescription: "Review submitted operation reports for a vessel."
  },

  operationReportSubmissionView: {
    url: "/report/operation-submission/view",
    metaTitle: "Operational Report | Vessel Daily Performance Summary",
    metaDescription: "View a submitted operation report."
  },




  oconMEComponentRunningHoursReportCreate: {
    url: "/report/ocon-me-component-running-hours/create",
    metaTitle: "Noon Report | Vessel Daily Performance Summary",
    metaDescription:
      "Create and review noon reports with vessel position, speed, weather conditions, fuel consumption, and engine performance data."
  },


  sternTubeRecordingReportCreate: {
    url: "/report/stern-tube-recordings/create",
    metaTitle: "Noon Report | Vessel Daily Performance Summary",
    metaDescription:
      "Create and review noon reports with vessel position, speed, weather conditions, fuel consumption, and engine performance data."
  },


  sternTubeRecordingReportList: {
    url: "/report/stern-tube/list",
    metaTitle: "Operational Report | Vessel Daily Performance Summary",
    metaDescription:
      "Create and review noon reports with vessel position, speed, weather conditions, fuel consumption, and engine performance data."
  },
  sternTubeRecordingReportPreview: {
    url: "/report/stern-tube/view",
    metaTitle: "Operational Report | Vessel Daily Performance Summary",
    metaDescription:
      "Create and review noon reports with vessel position, speed, weather conditions, fuel consumption, and engine performance data."
  },



  essentialMotorsRecordSheetCreate: {
    url: "/report/essential-motors-record-sheet/create",
    metaTitle: "Operational Report | Vessel Daily Performance Summary",
    metaDescription:
      "Log a new machinery space oil operation under MARPOL Oil Record Book Part II."
  },

  equipmentCalibrationRegisterCreate: {
    url: "/report/equipment-calibration-register/create",
    metaTitle: "Operational Report | Vessel Daily Performance Summary",
    metaDescription:
      "Log a new machinery space oil operation under MARPOL Oil Record Book Part II."
  },

  srdDamageClaimReportCreate: {
    url: "/report/sdr-damage-claim/create",
    metaTitle: "Operational Report | Vessel Daily Performance Summary",
    metaDescription:
      "Create and review noon reports with vessel position, speed, weather conditions, fuel consumption, and engine performance data."
  },


  srdDamageClaimReportList: {
    url: "/report/sdr-damage-claim/list",
    metaTitle: "Operational Report | Vessel Daily Performance Summary",
    metaDescription:
      "Create and review noon reports with vessel position, speed, weather conditions, fuel consumption, and engine performance data."
  },





  LubripadInspection: {
    url: "/report/lubripad-inspection/create",
    metaTitle: "Oil Record Book Part II | MARPOL Part II",
    metaDescription:
      "Log a new machinery space oil operation under MARPOL Oil Record Book Part II."
  },
  StatusOfPendingStevedoreDamages: {
    url: "/report/status-of-pending-stevedore-damages/create",
    metaTitle: "Oil Record Book Part II | MARPOL Part II",
    metaDescription:
      "Log a new machinery space oil operation under MARPOL Oil Record Book Part II."
  },
  StatusOfPendingStevedoreDamagesDrydockDeferredRepairs: {
    url: "/report/status-of-pending-stevedore-damages-drydock-deferred-repairs/create",
    metaTitle: "Oil Record Book Part II | MARPOL Part II",
    metaDescription:
      "Log a new machinery space oil operation under MARPOL Oil Record Book Part II."
  },


  delayDeviationStatement: {
    url: "/report/delay-deviation-statement/create",
    metaTitle: "Oil Record Book Part II | MARPOL Part II",
    metaDescription:
      "Log a new machinery space oil operation under MARPOL Oil Record Book Part II."
  },



  customerPropertyInventoryCreate: {
    url: "/report/customer-property-inventory/create",
    metaTitle: "Oil Record Book Part II | MARPOL Part II",
    metaDescription:
      "Log a new machinery space oil operation under MARPOL Oil Record Book Part II."
  },


  customerPropertyInventoryList: {
    url: "/report/customer-property-inventory/list",
    metaTitle: "Oil Record Book Part II | MARPOL Part II",
    metaDescription:
      "Log a new machinery space oil operation under MARPOL Oil Record Book Part II."
  },


  customerPropertyInventoryView: {
    url: "/report/customer-property-inventory/view",
    metaTitle: "Oil Record Book Part II | MARPOL Part II",
    metaDescription:
      "Log a new machinery space oil operation under MARPOL Oil Record Book Part II."
  },

  groupInsuranceFormsCreate: {
    url: "/reportgroup-insurance-forms",
    metaTitle: "Oil Record Book Part II | MARPOL Part II",
    metaDescription:
      "Log a new machinery space oil operation under MARPOL Oil Record Book Part II."
  },
  MECrankshaftBearingConditiondeflectionCreate: {
    url: "/report/me-crankshaft-bearing-conditiondeflections",
    metaTitle: "Oil Record Book Part II | MARPOL Part II",
    metaDescription:
      "Log a new machinery space oil operation under MARPOL Oil Record Book Part II."
  },
  AECrankshaftBearingConditiondeflectionsCreate: {
    url: "/report/ae-crankshaft-bearing-conditiondeflections",
    metaTitle: "Oil Record Book Part II | MARPOL Part II",
    metaDescription:
      "Log a new machinery space oil operation under MARPOL Oil Record Book Part II."
  },

  reeferContainerSparePartsInventoryReportCreate: {
    url: "/report/reefer-container-spare-parts-inventory/create",
    metaTitle: "Operational Report | Vessel Daily Performance Summary",
    metaDescription:
      "Create and review noon reports with vessel position, speed, weather conditions, fuel consumption, and engine performance data."
  },



  navigationEquipmentReportCreate: {
    url: "/report/navigation-equipment-reports/create",
    metaTitle: "Operational Report | Vessel Daily Performance Summary",
    metaDescription:
      "Create and review noon reports with vessel position, speed, weather conditions, fuel consumption, and engine performance data."
  },


  eomReportCreate: {
    url: "/report/eom/create",
    metaTitle: "Operational Report | Vessel Daily Performance Summary",
    metaDescription:
      "Create and review noon reports with vessel position, speed, weather conditions, fuel consumption, and engine performance data."
  },


  auxiliaryEnginePerformaceDataReportCreate: {
    url: "/report/ae-performace/create",
    metaTitle: "Operational Report | Vessel Daily Performance Summary",
    metaDescription:
      "Create and review noon reports with vessel position, speed, weather conditions, fuel consumption, and engine performance data."
  },



  auxiliaryEnginePerformaceDataReportList: {
    url: "/report/ae-performace/list",
    metaTitle: "Operational Report | Vessel Daily Performance Summary",
    metaDescription:
      "Create and review noon reports with vessel position, speed, weather conditions, fuel consumption, and engine performance data."
  },



  createReportList: {
    url: "/report/create-report",
    metaTitle: "Operational Report | Vessel Daily Performance Summary",
    metaDescription:
      "Create and review noon reports with vessel position, speed, weather conditions, fuel consumption, and engine performance data."
  },
  operationReportView: {
    url: "/report/operation/view",
    metaTitle: "Submitted Operation Report | iSHIP+",
    metaDescription: "Read-only view of a submitted operation report for office and admin review.",
  },


  /* ===================== MARPOL MODULE ===================== */

  // ── Oil Record Book Part I (Codes A–I) ──

  marpolOrbPart1Dashboard: {
    url: "/marpol/oil-record-book-part-1/dashboard",
    metaTitle: "Oil Record Book Part I Dashboard | MARPOL",
    metaDescription: "Dashboard overview of Oil Record Book Part I operations and compliance status."
  },
  marpolOrbPart1NewEntry: {
    url: "/marpol/oil-record-book-part-1/new-entry",
    metaTitle: "New Entry — Oil Record Book Part I | MARPOL",
    metaDescription: "Create a new Oil Record Book Part I entry for machinery space operations."
  },
  marpolOrbPart1History: {
    url: "/marpol/oil-record-book-part-1/history",
    metaTitle: "Entry History — Oil Record Book Part I | MARPOL",
    metaDescription: "View historical Oil Record Book Part I entries for compliance and audits."
  },
  marpolOrbPart1Approvals: {
    url: "/marpol/oil-record-book-part-1/approvals",
    metaTitle: "Approvals — Oil Record Book Part I | MARPOL",
    metaDescription: "Approve or reject Oil Record Book Part I entries (Chief Engineer / Master)."
  },
  marpolOrbPart1CodeA: {
    url: "/marpol/oil-record-book-part-1/code-a",
    metaTitle: "Code A — Ballasting / Cleaning of Oil Fuel Tanks | MARPOL ORB Part I",
    metaDescription: "Log ballasting or cleaning of oil fuel tanks under MARPOL ORB Part I."
  },
  marpolOrbPart1CodeB: {
    url: "/marpol/oil-record-book-part-1/code-b",
    metaTitle: "Code B — Discharge of Dirty Ballast | MARPOL ORB Part I",
    metaDescription: "Log discharge of dirty ballast or cleaning water under MARPOL ORB Part I."
  },
  marpolOrbPart1CodeC: {
    url: "/marpol/oil-record-book-part-1/code-c",
    metaTitle: "Code C — Sludge Collection & Disposal | MARPOL ORB Part I",
    metaDescription: "Log collection, transfer and disposal of oil residues (sludge)."
  },
  marpolOrbPart1CodeD: {
    url: "/marpol/oil-record-book-part-1/code-d",
    metaTitle: "Code D — Non-Automatic Bilge Discharge | MARPOL ORB Part I",
    metaDescription: "Log non-automatic discharge or transfer of bilge water."
  },
  marpolOrbPart1CodeE: {
    url: "/marpol/oil-record-book-part-1/code-e",
    metaTitle: "Code E — Automatic Bilge Discharge | MARPOL ORB Part I",
    metaDescription: "Log automatic bilge water discharge or transfer operations."
  },
  marpolOrbPart1CodeF: {
    url: "/marpol/oil-record-book-part-1/code-f",
    metaTitle: "Code F — Oil Filtering Equipment Condition | MARPOL ORB Part I",
    metaDescription: "Record OWS, OCM, or 15ppm equipment failure and restoration."
  },
  marpolOrbPart1CodeG: {
    url: "/marpol/oil-record-book-part-1/code-g",
    metaTitle: "Code G — Accidental Oil Discharge | MARPOL ORB Part I",
    metaDescription: "Record accidental or exceptional discharge of oil."
  },
  marpolOrbPart1CodeH: {
    url: "/marpol/oil-record-book-part-1/code-h",
    metaTitle: "Code H — Fuel Oil Bunkering | MARPOL ORB Part I",
    metaDescription: "Log bunkering of fuel oil or bulk lubricating oil."
  },
  marpolOrbPart1CodeI: {
    url: "/marpol/oil-record-book-part-1/code-i",
    metaTitle: "Code I — Missed Entry & Additional Operations | MARPOL ORB Part I",
    metaDescription: "Record missed operational entries or additional procedures (I.1–I.4).",
  },

  // ── Oil Record Book Part II (Codes A–L) ──
  marpolOrbPart2Dashboard: {
    url: "/marpol/oil-record-book-part-2/dashboard",
    metaTitle: "Oil Record Book Part II Dashboard | MARPOL",
    metaDescription: "Dashboard overview of Oil Record Book Part II cargo and ballast operations."
  },
  marpolOrbPart2NewEntry: {
    url: "/marpol/oil-record-book-part-2/new-entry",
    metaTitle: "New Entry — Oil Record Book Part II | MARPOL",
    metaDescription: "Create a new Oil Record Book Part II entry for cargo/ballast operations."
  },
  marpolOrbPart2History: {
    url: "/marpol/oil-record-book-part-2/history",
    metaTitle: "Entry History — Oil Record Book Part II | MARPOL",
    metaDescription: "View historical Oil Record Book Part II entries."
  },
  marpolOrbPart2Approvals: {
    url: "/marpol/oil-record-book-part-2/approvals",
    metaTitle: "Approvals — Oil Record Book Part II | MARPOL",
    metaDescription: "Review and sign Oil Record Book Part II entries."
  },
  marpolOrbPart2CodeA: { url: "/marpol/oil-record-book-part-2/code-a", metaTitle: "Code A — Loading of Oil Cargo | MARPOL ORB Part II", metaDescription: "Log loading of oil cargo." },
  marpolOrbPart2CodeB: { url: "/marpol/oil-record-book-part-2/code-b", metaTitle: "Code B — Internal Transfer | MARPOL ORB Part II", metaDescription: "Log internal transfer of oil cargo during voyage." },
  marpolOrbPart2CodeC: { url: "/marpol/oil-record-book-part-2/code-c", metaTitle: "Code C — Unloading of Oil Cargo | MARPOL ORB Part II", metaDescription: "Log unloading of oil cargo." },
  marpolOrbPart2CodeD: { url: "/marpol/oil-record-book-part-2/code-d", metaTitle: "Code D — Ballasting of Cargo Tanks | MARPOL ORB Part II", metaDescription: "Log ballasting of cargo tanks." },
  marpolOrbPart2CodeE: { url: "/marpol/oil-record-book-part-2/code-e", metaTitle: "Code E — Cleaning of Cargo Tanks | MARPOL ORB Part II", metaDescription: "Log cleaning of cargo tanks." },
  marpolOrbPart2CodeF: { url: "/marpol/oil-record-book-part-2/code-f", metaTitle: "Code F — Discharge of Dirty Ballast | MARPOL ORB Part II", metaDescription: "Log discharge of dirty ballast from cargo tanks." },
  marpolOrbPart2CodeG: { url: "/marpol/oil-record-book-part-2/code-g", metaTitle: "Code G — Discharge from Slop Tanks | MARPOL ORB Part II", metaDescription: "Log discharge of water from slop tanks." },
  marpolOrbPart2CodeH: { url: "/marpol/oil-record-book-part-2/code-h", metaTitle: "Code H — Disposal of Residues | MARPOL ORB Part II", metaDescription: "Log disposal of cargo residues." },
  marpolOrbPart2CodeI: { url: "/marpol/oil-record-book-part-2/code-i", metaTitle: "Code I — CBT Ballast Discharge | MARPOL ORB Part II", metaDescription: "Log discharge from dedicated clean ballast tanks." },
  marpolOrbPart2CodeJ: { url: "/marpol/oil-record-book-part-2/code-j", metaTitle: "Code J — Crude Oil Washing | MARPOL ORB Part II", metaDescription: "Log crude oil washing operations." },
  marpolOrbPart2CodeK: { url: "/marpol/oil-record-book-part-2/code-k", metaTitle: "Code K — ODMC System Condition | MARPOL ORB Part II", metaDescription: "Record ODMC system status." },
  marpolOrbPart2CodeL: { url: "/marpol/oil-record-book-part-2/code-l", metaTitle: "Code L — Accidental Discharges | MARPOL ORB Part II", metaDescription: "Record accidental or exceptional cargo discharges." },
  marpolOrbPart2CodeO: {
    url: "/marpol/oil-record-book-part-2/code-o",
    metaTitle: "Code O — Missed Operational Entry | MARPOL ORB Part II",
    metaDescription: "Record an earlier missed operational entry per MEPC.312.",
  },

  // ── Garbage Record Book (4 Entry Types) ──
  marpolGarbageDashboard: {
    url: "/marpol/garbage-record-book/dashboard",
    metaTitle: "Garbage Record Book Dashboard | MARPOL Annex V",
    metaDescription: "Dashboard overview of garbage record book operations and compliance."
  },
  marpolGarbageNewEntry: {
    url: "/marpol/garbage-record-book/new-entry",
    metaTitle: "New Entry — Garbage Record Book | MARPOL",
    metaDescription: "Create a new garbage disposal or handling entry."
  },
  marpolGarbageHistory: {
    url: "/marpol/garbage-record-book/history",
    metaTitle: "Entry History — Garbage Record Book | MARPOL",
    metaDescription: "View historical garbage record book entries."
  },
  marpolGarbageApprovals: {
    url: "/marpol/garbage-record-book/approvals",
    metaTitle: "Approvals — Garbage Record Book | MARPOL",
    metaDescription: "Review and sign Garbage Record Book entries."
  },
  marpolGarbageType1: { url: "/marpol/garbage-record-book/type-1", metaTitle: "Type 1 — PRF Delivery | MARPOL GRB", metaDescription: "Record delivery of garbage to port reception facility." },
  marpolGarbageType2: { url: "/marpol/garbage-record-book/type-2", metaTitle: "Type 2 — Incineration | MARPOL GRB", metaDescription: "Record garbage incineration operation." },
  marpolGarbageType3: { url: "/marpol/garbage-record-book/type-3", metaTitle: "Type 3 — Discharge at Sea | MARPOL GRB", metaDescription: "Record permitted garbage discharge at sea." },
  marpolGarbageType4: { url: "/marpol/garbage-record-book/type-4", metaTitle: "Type 4 — Accidental Loss | MARPOL GRB", metaDescription: "Record accidental or exceptional loss of garbage." },
  marpolGarbageMissedEntry: {
    url: "/marpol/missed-entry/grb",
    metaTitle: "Type i — Missed Entry | MARPOL GRB",
    metaDescription: "Record an earlier missed garbage record book entry.",
  },

  // ── Ballast Water Record Book (Codes A–H) ──
  marpolBallastDashboard: {
    url: "/marpol/ballast-water-record/dashboard",
    metaTitle: "Ballast Water Record Dashboard | MARPOL BWM",
    metaDescription: "Dashboard overview of ballast water operations and compliance."
  },
  marpolBallastNewEntry: {
    url: "/marpol/ballast-water-record/new-entry",
    metaTitle: "New Entry — Ballast Water Record | MARPOL",
    metaDescription: "Create a new ballast water operation entry."
  },
  marpolBallastHistory: {
    url: "/marpol/ballast-water-record/history",
    metaTitle: "Entry History — Ballast Water Record | MARPOL",
    metaDescription: "View historical ballast water operation entries."
  },
  marpolBallastApprovals: {
    url: "/marpol/ballast-water-record/approvals",
    metaTitle: "Approvals — Ballast Water Record | MARPOL",
    metaDescription: "Review and sign Ballast Water Record entries."
  },
  marpolBallastCodeA: { url: "/marpol/ballast-water-record/code-a", metaTitle: "Code A — Uptake of Ballast Water | MARPOL BWRB", metaDescription: "Record ballast water uptake." },
  marpolBallastCodeB: { url: "/marpol/ballast-water-record/code-b", metaTitle: "Code B — BW Exchange (D-1) | MARPOL BWRB", metaDescription: "Record ballast water exchange at sea." },
  marpolBallastCodeC: { url: "/marpol/ballast-water-record/code-c", metaTitle: "Code C — BW Discharge (D-2 BWMS) | MARPOL BWRB", metaDescription: "Record ballast water discharge via BWMS." },
  marpolBallastCodeD: { url: "/marpol/ballast-water-record/code-d", metaTitle: "Code D — BW to Reception Facility | MARPOL BWRB", metaDescription: "Record discharge to reception facility." },
  marpolBallastCodeE: { url: "/marpol/ballast-water-record/code-e", metaTitle: "Code E — BW Transfer to Another Ship | MARPOL BWRB", metaDescription: "Record transfer to another vessel." },
  marpolBallastCodeF: { url: "/marpol/ballast-water-record/code-f", metaTitle: "Code F — BWMS Failure | MARPOL BWRB", metaDescription: "Record BWMS failure or unusual situation." },
  marpolBallastCodeG: { url: "/marpol/ballast-water-record/code-g", metaTitle: "Code G — Tank Cleaning / Sediment | MARPOL BWRB", metaDescription: "Record ballast tank cleaning or sediment removal." },
  marpolBallastCodeH: { url: "/marpol/ballast-water-record/code-h", metaTitle: "Code H — Challenging Water Quality | MARPOL BWRB", metaDescription: "Record challenging water quality conditions." },
  marpolBallastMissedEntry: {
    url: "/marpol/missed-entry/bwr",
    metaTitle: "Code I — Missed Entry | MARPOL BWRB",
    metaDescription: "Record an earlier missed ballast water record entry.",
  },

  // ── Biofouling Record Book (3 Sections) ──
  marpolBiofoulingDashboard: {
    url: "/marpol/biofouling-record-book/dashboard",
    metaTitle: "Biofouling Record Book Dashboard | MARPOL",
    metaDescription: "Dashboard overview of biofouling record book and AFS compliance."
  },
  marpolBiofoulingNewEntry: {
    url: "/marpol/biofouling-record-book/new-entry",
    metaTitle: "New Entry — Biofouling Record Book | MARPOL",
    metaDescription: "Create a new biofouling inspection, AFS, or cleaning entry."
  },
  marpolBiofoulingHistory: {
    url: "/marpol/biofouling-record-book/history",
    metaTitle: "Entry History — Biofouling Record Book | MARPOL",
    metaDescription: "View historical biofouling record book entries."
  },
  marpolBiofoulingApprovals: {
    url: "/marpol/biofouling-record-book/approvals",
    metaTitle: "Approvals — Biofouling Record Book | MARPOL",
    metaDescription: "Review and sign Biofouling Record Book entries."
  },
  marpolBiofoulingSection1: { url: "/marpol/biofouling-record-book/section-1", metaTitle: "Section 1 — AFS Record | MARPOL BFRB", metaDescription: "Record anti-fouling system application details." },
  marpolBiofoulingSection2: { url: "/marpol/biofouling-record-book/section-2", metaTitle: "Section 2 — In-Service Inspection | MARPOL BFRB", metaDescription: "Record in-service fouling inspection with ratings." },
  marpolBiofoulingSection3: { url: "/marpol/biofouling-record-book/section-3", metaTitle: "Section 3 — Cleaning Report | MARPOL BFRB", metaDescription: "Record hull cleaning report." },

  // ── Annex IV Record (4 Entry Types) ──
  marpolAnnexIVDashboard: {
    url: "/marpol/annex-iv-record/dashboard",
    metaTitle: "Annex IV Record Dashboard | MARPOL",
    metaDescription: "Dashboard overview of Annex IV sewage management records."
  },
  marpolAnnexIVNewEntry: {
    url: "/marpol/annex-iv-record/new-entry",
    metaTitle: "New Entry — Annex IV Record | MARPOL",
    metaDescription: "Create a new Annex IV sewage management entry."
  },
  marpolAnnexIVHistory: {
    url: "/marpol/annex-iv-record/history",
    metaTitle: "Entry History — Annex IV Record | MARPOL",
    metaDescription: "View historical Annex IV sewage records."
  },
  marpolAnnexIVApprovals: {
    url: "/marpol/annex-iv-record/approvals",
    metaTitle: "Approvals — Annex IV Record | MARPOL",
    metaDescription: "Review and sign Annex IV records."
  },
  marpolAnnexIVType1: { url: "/marpol/annex-iv-record/type-1", metaTitle: "Type 1 — STP Daily Log | MARPOL Annex IV", metaDescription: "Record STP daily operational log." },
  marpolAnnexIVType2: { url: "/marpol/annex-iv-record/type-2", metaTitle: "Type 2 — Treated Sewage Discharge | MARPOL Annex IV", metaDescription: "Record discharge of treated sewage at sea." },
  marpolAnnexIVType3: { url: "/marpol/annex-iv-record/type-3", metaTitle: "Type 3 — Sewage to PRF | MARPOL Annex IV", metaDescription: "Record discharge of sewage to port reception facility." },
  marpolAnnexIVType4: { url: "/marpol/annex-iv-record/type-4", metaTitle: "Type 4 — Holding Tank Status | MARPOL Annex IV", metaDescription: "Record sewage holding tank status." },
  marpolAnnexIVMissedEntry: {
    url: "/marpol/missed-entry/annex-iv",
    metaTitle: "Type i — Missed Entry | MARPOL Annex IV",
    metaDescription: "Record an earlier missed Annex IV entry.",
  },

  // ── Annex VI Record (10 Entry Types) ──
  marpolAnnexVIDashboard: {
    url: "/marpol/annex-vi-record/dashboard",
    metaTitle: "Annex VI Record Dashboard | MARPOL",
    metaDescription: "Dashboard overview of Annex VI air pollution prevention records."
  },
  marpolAnnexVINewEntry: {
    url: "/marpol/annex-vi-record/new-entry",
    metaTitle: "New Entry — Annex VI Record | MARPOL",
    metaDescription: "Create a new Annex VI air pollution prevention entry."
  },
  marpolAnnexVIHistory: {
    url: "/marpol/annex-vi-record/history",
    metaTitle: "Entry History — Annex VI Record | MARPOL",
    metaDescription: "View historical Annex VI air pollution records."
  },
  marpolAnnexVIApprovals: {
    url: "/marpol/annex-vi-record/approvals",
    metaTitle: "Approvals — Annex VI Record | MARPOL",
    metaDescription: "Review and sign Annex VI records."
  },
  marpolAnnexVICodeA: { url: "/marpol/annex-vi-record/code-a", metaTitle: "Code A — Bunkering | MARPOL Annex VI", metaDescription: "Record bunkering of low sulphur fuel oil." },
  marpolAnnexVICodeB: { url: "/marpol/annex-vi-record/code-b", metaTitle: "Code B — Sample Tracking | MARPOL Annex VI", metaDescription: "Record tracking of MARPOL fuel oil samples." },
  marpolAnnexVICodeC: { url: "/marpol/annex-vi-record/code-c", metaTitle: "Code C — Sample Transfer | MARPOL Annex VI", metaDescription: "Record transfer of custody of MARPOL fuel oil samples." },
  marpolAnnexVICodeD: { url: "/marpol/annex-vi-record/code-d", metaTitle: "Code D — Changeover | MARPOL Annex VI", metaDescription: "Record SECA fuel changeover." },
  marpolAnnexVICodeE: { url: "/marpol/annex-vi-record/code-e", metaTitle: "Code E — EGCS | MARPOL Annex VI", metaDescription: "Record exhaust gas cleaning system operation." },
  marpolAnnexVICodeF: { url: "/marpol/annex-vi-record/code-f", metaTitle: "Code F — NECA | MARPOL Annex VI", metaDescription: "Record NOx emission control area operations." },
  marpolAnnexVICodeG: { url: "/marpol/annex-vi-record/code-g", metaTitle: "Code G — EGR | MARPOL Annex VI", metaDescription: "Record exhaust gas recirculation operations." },
  marpolAnnexVICodeH: { url: "/marpol/annex-vi-record/code-h", metaTitle: "Code H — Failure | MARPOL Annex VI", metaDescription: "Record emission abatement system failure." },
  marpolAnnexVICodeI: { url: "/marpol/annex-vi-record/code-i", metaTitle: "Code I — ODS | MARPOL Annex VI", metaDescription: "Record ozone depleting substances operations." },
  marpolAnnexVICodeJ: { url: "/marpol/annex-vi-record/code-j", metaTitle: "Code J — Additional | MARPOL Annex VI", metaDescription: "Record additional operational procedures." },
  marpolAnnexVIMissedEntry: {
    url: "/marpol/missed-entry/annex-vi",
    metaTitle: "Code I — Missed Entry | MARPOL Annex VI",
    metaDescription: "Record an earlier missed Annex VI entry.",
  },

  portArrivalReportCreate: {
    url: "/report/port-arrival",
    metaTitle: "EOSP Report | Vessel Safety & Operational Status",
    metaDescription:
      "Create and manage EOSP reports including vessel safety status, operational conditions, incidents, and compliance-related information."
  },
  eospReportCreate: {
    url: "/report/eosp",
    metaTitle: "EOSP Report | Vessel Safety & Operational Status",
    metaDescription:
      "Create and manage EOSP reports including vessel safety status, operational conditions, incidents, and compliance-related information."
  },
  sospReportCreate: {
    url: "/report/sosp",
    metaTitle: "SOSP Report | Shipboard Oil Spill Prevention",
    metaDescription:
      "Create and manage SOSP reports including oil spill prevention measures and compliance information."
  },

  startVoyage: {
    url: "/report/port-departure",
    metaTitle: "Port Departure | Vessel Departure Report & Clearance",
    metaDescription:
      "Record vessel port departure details including departure port, date & time, pilot off, tug release, draft, cargo status, and initial voyage parameters."
  },

  vesselReports: {
    url: "/vessel/reports",
    metaTitle: "Vessel Reports | Vessel Journey Logs & Performance Reports",
    metaDescription:
      "View and manage complete voyage reports including port departure, arrival, noon reports, fuel consumption, weather conditions, and vessel performance logs."
  },
  adminVesselReports: {
    url: "/admin/vessel-reports",
    metaTitle: "Vessel-Wise Submitted Reports | Fleet Rollup",
    metaDescription:
      "Read-only Super Admin view of every report category submitted by each vessel across the fleet."
  },
  fpctReport: {
    url: "/admin/vessel-reports/fpct",
    metaTitle: "FPCT Report | Fleet Performance Comparison",
    metaDescription:
      "Fleet Performance Comparison Tool — speed vs fuel oil consumption for main engine, generator, and boiler."
  },
  adminVesselReportDetail: {
    url: "/admin/vessel-reports/:vesselId",
    metaTitle: "Vessel Report Detail | Submitted Reports",
    metaDescription:
      "Drill-down view of every report category submitted by a single vessel, grouped in the classic left-rail layout."
  },
  adminActivityLog: {
    url: "/admin/activity-log",
    metaTitle: "Activity & IP Log | Platform Audit Trail",
    metaDescription:
      "View all user actions with IP address, user name, and compliance audit events across the platform."
  },
  listActivity: {
    url: "/admin/activity-log",
    metaTitle: "Activity & IP Log | Platform Audit Trail",
    metaDescription:
      "View all user actions with IP address, user name, and compliance audit events."
  },
  nearMissDashboard: {
    url: "/safety/near-miss",
    metaTitle: "Near Miss Dashboard | Safety Reporting",
    metaDescription:
      "Fleet near miss summary with open cases, high-risk items, and corrective action status."
  },
  nearMissNewEntry: {
    url: "/safety/near-miss/new-report",
    metaTitle: "New Near Miss / Incident Report | Safety",
    metaDescription:
      "Report near misses, accidents, and unsafe acts or conditions onboard."
  },
  nearMissHistory: {
    url: "/safety/near-miss/history",
    metaTitle: "Near Miss History | Safety Reporting",
    metaDescription:
      "View vessel near miss and incident report history with workflow status."
  },
  nearMissDetail: {
    url: "/safety/near-miss/report",
    metaTitle: "Incident Report Detail | Safety",
    metaDescription:
      "Review, investigate, and close near miss and incident reports."
  },
  coNightOrderNewEntry: {
    url: "/logs/co-night-order/new-entry",
    metaTitle: "C/O Night Order Book — New Entry | LOG 5",
    metaDescription:
      "Chief Officer issues date-specific night orders to the Officer of the Watch."
  },
  coNightOrderHistory: {
    url: "/logs/co-night-order/history",
    metaTitle: "C/O Night Order Book — History | LOG 5",
    metaDescription:
      "View standing orders and history of Chief Officer night orders with OOW acknowledgements."
  },
  ceNightOrderNewEntry: {
    url: "/logs/ce-night-order/new-entry",
    metaTitle: "Engine Night Order Book — New Entry | LOG 6",
    metaDescription:
      "Chief Engineer issues date-specific night orders to duty engineers."
  },
  ceNightOrderHistory: {
    url: "/logs/ce-night-order/history",
    metaTitle: "Engine Night Order Book — History | LOG 6",
    metaDescription:
      "View standing orders and history of Chief Engineer night orders with engine officer acknowledgements."
  },
  bridgeNightOrderNewEntry: {
    url: "/logs/bridge-night-order/new-entry",
    metaTitle: "Bridge Night Order Book — New Entry | LOG 4",
    metaDescription:
      "Master issues date-specific bridge night orders to deck officers."
  },
  bridgeNightOrderHistory: {
    url: "/logs/bridge-night-order/history",
    metaTitle: "Bridge Night Order Book — History | LOG 4",
    metaDescription:
      "View standing orders and history of Master bridge night orders with deck officer acknowledgements."
  },
  compassErrorLogNewEntry: {
    url: "/logs/compass-error/new-entry",
    metaTitle: "Compass Error Log — New Entry | LOG 1",
    metaDescription:
      "Record compass error observations with gyro, magnetic, variation, and deviation calculations."
  },
  compassErrorLogHistory: {
    url: "/logs/compass-error/history",
    metaTitle: "Compass Error Log — History | LOG 1",
    metaDescription:
      "View all compass error log entries with OOW signatures per SOLAS Ch.V Reg.19."
  },
  cargoLog: {
    url: "/logs/cargo-log",
    metaTitle: "Cargo Log | E-Logs",
    metaDescription: "Record cargo loading, discharging, and shifting operations."
  },
  gmdssLog: {
    url: "/logs/gmdss",
    metaTitle: "GMDSS Log | Radio Communications",
    metaDescription:
      "Record GMDSS equipment tests, battery checks, and radio watchkeeping notes."
  },
  portCallLog: {
    url: "/report/port-departure",
    metaTitle: "Port Call Log | Voyage Port Report",
    metaDescription:
      "Voyage port report — port information, cargo, and operational log activity."
  },
  permitToWork: {
    url: "/operations/ptw",
    metaTitle: "Permit to Work | Operations",
    metaDescription: "Request, approve, and close permits to work onboard."
  },
  crewRestHours: {
    url: "/operations/crew-rest",
    metaTitle: "Crew Rest Hours | STCW Compliance",
    metaDescription: "Record and review seafarer hours of work and rest."
  },
  formBuilder: {
    url: "/operations/forms",
    metaTitle: "Form Builder | Dynamic Forms",
    metaDescription: "Create, publish, and submit configurable operational forms."
  },
  myDailyReports: {
    url: "/my-reports",
    metaTitle: "Daily Vessel Reports | Vessel Journey Logs & Performance Reports",
    metaDescription:
      "View and manage complete voyage reports including port departure, arrival, noon reports, fuel consumption, weather conditions, and vessel performance logs."
  },
  // 📂 Event Category Master
  addActivityTypeCategory: {
    url: "/activity/category/add",
    metaTitle: "Add Event Category | Vessel Inspection Portal",
    metaDescription:
      "Create a new event category such as Inspection, Incident, Audit, or Observation for vessel events."
  },
  editActivityTypeCategory: {
    url: "/activity/category/edit",
    metaTitle: "Edit Event Category | Vessel Inspection Portal",
    metaDescription:
      "Edit an existing event category to keep event classification accurate and up to date."
  },
  listActivityTypeCategory: {
    url: "/activity/category/list",
    metaTitle: "Event Categories | Vessel Inspection Portal",
    metaDescription:
      "View and manage all event categories used across inspections, incidents, and vessel activities."
  },


  // 📅 Event Master
  addActivityType: {
    url: "/activity/add",
    metaTitle: "Add Event | Vessel Inspection Portal",
    metaDescription:
      "Create a new event under a selected category for inspections, incidents, or vessel activities."
  },
  editActivityType: {
    url: "/activity/edit",
    metaTitle: "Edit Event | Vessel Inspection Portal",
    metaDescription:
      "Edit event details such as name, code, or description linked to vessel operations."
  },
  listActivityType: {
    url: "/activity/list",
    metaTitle: "Event Master | Vessel Inspection Portal",
    metaDescription:
      "Manage all events categorized under inspections, incidents, audits, and compliance activities."
  },



  // 🌍 UN/LOCODE Master
  addUNLocode: {
    url: "/unlocode/add",
    metaTitle: "Add UN/LOCODE | Vessel Inspection Portal",
    metaDescription:
      "Add a new UN/LOCODE for ports, airports, ICDs, and logistics locations as per UNECE standards."
  },

  editUNLocode: {
    url: "/unlocode/edit",
    metaTitle: "Edit UN/LOCODE | Vessel Inspection Portal",
    metaDescription:
      "Edit or update UN/LOCODE details including location name, function, status, and coordinates."
  },

  listUNLocode: {
    url: "/unlocode/list",
    metaTitle: "UN/LOCODE Master | Vessel Inspection Portal",
    metaDescription:
      "Browse and manage all UN/LOCODE entries for ports, airports, terminals, and inland locations."
  },


  // 🌊 Sea State Master
  addSeaState: {
    url: "/sea-state/add",
    metaTitle: "Add Sea State | Vessel Inspection Portal",
    metaDescription:
      "Add a new sea state based on the Douglas Sea Scale to record sea conditions during voyages, noon reports, and deck logs."
  },

  editSeaState: {
    url: "/sea-state/edit",
    metaTitle: "Edit Sea State | Vessel Inspection Portal",
    metaDescription:
      "Edit or update sea state details including code, description, and wave height range as per maritime standards."
  },

  listSeaState: {
    url: "/sea-state/list",
    metaTitle: "Sea State Master | Vessel Inspection Portal",
    metaDescription:
      "Browse and manage all sea states defined under the Douglas Sea Scale for accurate weather and voyage condition reporting."
  },


  // 📦 IMPA Master
  addIMPA: {
    url: "/impa/add",
    metaTitle: "Add IMPA Code | Vessel Inspection Portal",
    metaDescription:
      "Add a new IMPA marine stores code with description, section, and unit of measure."
  },

  editIMPA: {
    url: "/impa/edit",
    metaTitle: "Edit IMPA Code | Vessel Inspection Portal",
    metaDescription:
      "Edit or update an IMPA marine stores code, description, section, and unit of measure."
  },

  listIMPA: {
    url: "/impa/list",
    metaTitle: "IMPA Codes | Vessel Inspection Portal",
    metaDescription:
      "Browse and manage the IMPA (International Marine Purchasing Association) marine stores code catalog."
  },

  vendorDashboard: {
    url: "/vendor-dashboard",
    metaTitle: "Vendor Dashboard | Vessel Inspection Portal",
    metaDescription:
      "Vendor dashboard — view fleet parts raised by crew and set or update pricing across every vessel at once."
  },

  shipyardDashboard: {
    url: "/shipyard-dashboard",
    metaTitle: "Shipyard Dashboard | Vessel Inspection Portal",
    metaDescription:
      "Shipyard dashboard — view drydock RFQs addressed to your yard and submit price and lead time quotes."
  },


  euMrvData: {
    url: "/eu-mrv-data",
    metaTitle: "EU MRV Data | Vessel Inspection Portal",
    metaDescription:
      "View and manage EU MRV (Monitoring, Reporting, and Verification) data including CO₂ emissions, fuel consumption, voyage details, and compliance records."
  },

  imoDcs: {
    url: "/imo-dcs",
    metaTitle: "IMO DCS Data | Vessel Inspection Portal",
    metaDescription:
      "Manage IMO DCS (Data Collection System) reports covering annual fuel oil consumption, distance traveled, hours underway, and regulatory compliance."
  },

  environment: {
    url: "/environment",
    metaTitle: "Environment | CII, EEOI & Emissions Compliance",
    metaDescription:
      "Monitor CII, EEOI, NOx, SOx, FuelEU Maritime, and EU-ETS compliance across the fleet from a single environment module."
  },

  vesselPerformance: {
    url: "/vessel-performance",
    metaTitle: "Vessel Performance | Fleet Intelligence",
    metaDescription:
      "Analyze speed, voyage, engine, fuel, hull, propeller, emissions, and business actions from vessel noon reports and operational records."
  },

  intelligenceWorkspace: {
    url: "/intelligence",
    metaTitle: "iShip Intelligence | Fleet & Document Analysis",
    metaDescription:
      "Ask questions across governed fleet records, vessel performance and an uploaded operating document from one focused workspace."
  },

  exploreServices: {
    url: "/explore",
    metaTitle: "Explore Services | iSHIP Marketplace",
    metaDescription:
      "Browse and request additional iSHIP modules — Vessel Inspection, Weekly Task Management, Daily Tasks Register, and more."
  },

  masterDataHub: {
    url: "/master-data",
    metaTitle: "Master Data | Vessels, Owners & Crew",
    metaDescription:
      "Shared master data for vessels, vessel owners, and crew members — the single source used across all iSHIP modules."
  },

  masterDataVendors: {
    url: "/master-data/vendors",
    metaTitle: "Vendors | Master Data",
    metaDescription:
      "Approved vendors, subcontractors, and suppliers — add vendor details with custom categories used across drydock and procurement."
  },

  masterDataDocumentTypes: {
    url: "/master-data/document-types",
    metaTitle: "Document & Certificate Types | Master Data",
    metaDescription:
      "Define vessel document and certificate requirements, validity periods, and expiry alerts.",
  },

  componentMaster: {
    url: "/master-data/components",
    metaTitle: "Equipment | Master Data",
    metaDescription:
      "Fleet equipment catalogue — equipment code, maker, model, vessel links, and job scope.",
  },

  masterEquipment: {
    url: "/master-data/equipment",
    metaTitle: "Equipment | Master Data",
    metaDescription:
      "Alias of Equipment master — fleet equipment catalogue used for vessel onboarding.",
  },

  maintenanceJobList: {
    url: "/master-data/job-list",
    metaTitle: "Job List | Master Data",
    metaDescription:
      "All planned maintenance jobs organized by component, subcomponent, interval, and responsible rank.",
  },

  masterDataImportMapping: {
    url: "/master-data/import-mapping",
    metaTitle: "Master Data Import & Mapping | PMS",
    metaDescription:
      "Upload Equipment Particulars and Standard Jobs, map onto PMS masters, create plans, and generate work orders.",
  },

  componentLinkedJobs: {
    url: "/master-data/components/:uid/jobs",
    metaTitle: "Linked Jobs | Component Master",
    metaDescription:
      "Planned maintenance jobs linked to a component or part in the machinery catalog.",
  },

  templateBuildersHub: {
    url: "/template-builders",
    metaTitle: "Template Builders | Vessel & Permit Templates",
    metaDescription:
      "Design reusable templates — vessel component trees, permit forms, and other builders — separate from live Master Data.",
  },

  settingsHub: {
    url: "/settings",
    metaTitle: "Settings | Users, Dictionaries & Config",
    metaDescription:
      "Administration hub for users, system dictionaries, vessel groups, and application configuration.",
  },

  deliveryNote: {
    url: "/procurement/delivery-note",
    metaTitle: "Delivery Note | Invoice & Packing List",
    metaDescription:
      "I-SHIP Solutions delivery note — invoice and packing list for ship's spare in transit.",
  },

  pmsVesselTemplate: {
    url: "/template-builders/vessel-template",
    metaTitle: "Vessel Template Builder",
    metaDescription:
      "Build vessel-type component templates and mind maps for machinery systems and parts.",
  },

  visualReportBuilder: {
    url: "/template-builders/report-builder",
    metaTitle: "Report Builder",
    metaDescription:
      "Design reusable report templates with a drag-and-drop canvas, headers/footers, and rich text.",
  },

  safetyTemplates: {
    url: "/template-builders/safety-templates",
    metaTitle: "Safety Templates | Drill Schedule",
    metaDescription:
      "Manage company safety-drill intervals within locked regulatory requirements.",
  },

  complianceTemplates: {
    url: "/template-builders/compliance-templates",
    metaTitle: "Compliance Templates | Template Builder",
    metaDescription:
      "Manage regulation-based compliance templates grouped by category with search, filters, and table workflows.",
  },

  inspectionsList: {
    url: "/compliance/inspections",
    metaTitle: "Vessel Inspections | Compliance",
    metaDescription:
      "Add and track vessel inspections instantiated from compliance templates, with fill-out progress and review/approval.",
  },

  inspectionDetail: {
    url: "/compliance/inspections/detail",
    metaTitle: "Inspection | Compliance",
    metaDescription:
      "Fill out an inspection's checklist and findings, submit for review, and approve or reject.",
  },

  pscInspectionChecklist: {
    url: "/template-builders/compliance-templates/psc-checklist",
    metaTitle: "PSC Inspection Checklist | Compliance Templates",
    metaDescription:
      "Complete the Port State Control inspection checklist grouped by vessel area — ship, process, cargo, ballast, navigation, engine, inspections, security, and management.",
  },

  vettingInspectionChecklist: {
    url: "/template-builders/compliance-templates/vetting-checklist",
    metaTitle: "Vetting Inspection Form | Compliance Templates",
    metaDescription:
      "Complete the vetting inspection smart form with section-based progress, draft saves, and company-aligned layout.",
  },

  customFormBuilder: {
    url: "/template-builders/other-reports",
    metaTitle: "Other Reports | Report Builder",
    metaDescription:
      "Design custom forms with drag-and-drop fields, assign to vessels, publish, and track submissions.",
  },

  myForms: {
    url: "/other-reports",
    metaTitle: "Other Reports",
    metaDescription: "Published forms assigned to your vessel — fill, save drafts, and submit.",
  },

  otherReports: {
    url: "/other-reports",
    metaTitle: "Other Reports",
    metaDescription: "Create, complete, submit, and export dynamic operational reports.",
  },

  reportBuilder: {
    url: "/template-builders/other-reports",
    metaTitle: "Other Reports Builder",
    metaDescription: "Visually build and version dynamic report templates.",
  },

  reportSubmissions: {
    url: "/other-reports/register",
    metaTitle: "Other Reports Register",
    metaDescription: "Review, approve, print, and export submitted reports.",
  },

  modulesRoot: {
    url: "/modules",
    metaTitle: "Modules | iSHIP Operations",
    metaDescription: "Maritime operational modules — Maintenance, Procurement, HSEQ, Drydock, Crew operations, and Inspection."
  },


  voyageConfiguration: {
    url: "/voyage/configuration",
    metaTitle: "IMO DCS Data | Vessel Inspection Portal",
    metaDescription:
      "Manage IMO DCS (Data Collection System) reports covering annual fuel oil consumption, distance traveled, hours underway, and regulatory compliance."
  },

  voyageRoutePlan: {
    url: "/voyage/route-plan",
    metaTitle: "Voyage Route Plan | Port-to-Port Schedule",
    metaDescription:
      "Plan the vessel voyage route with port calls, ETA, ETB, and ETD for each leg in sailing order."
  },

  kpiDashboard: {
    url: "/kpi/dashboard",
    metaTitle: "KPI Dashboard | Vessel Performance &  Monitoring",
    metaDescription:
      "View vessel performance KPIs and IMO DCS data including annual fuel consumption, distance traveled, hours underway, and regulatory compliance insights in one dashboard."
  },


  kpiTechnicalMainEngine: {
    url: "/kpi/technical/main-engine",
    metaTitle: "KPI Dashboard | Vessel Performance &  Monitoring",
    metaDescription:
      "View vessel performance KPIs and IMO DCS data including annual fuel consumption, distance traveled, hours underway, and regulatory compliance insights in one dashboard."
  },

  kpiTechnicalAuxEngine: {
    url: "/kpi/technical/aux-engine",
    metaTitle: "KPI Dashboard | Vessel Performance &  Monitoring",
    metaDescription:
      "View vessel performance KPIs and IMO DCS data including annual fuel consumption, distance traveled, hours underway, and regulatory compliance insights in one dashboard."
  },

  KPITechnicalPurifier: {
    url: "/kpi/technical/purifier",
    metaTitle: "KPI Dashboard | Vessel Performance &  Monitoring",
    metaDescription:
      "View vessel performance KPIs and IMO DCS data including annual fuel consumption, distance traveled, hours underway, and regulatory compliance insights in one dashboard."
  },
  KPITechnicalLoAnalysisReport: {
    url: "/kpi/technical/lo-analysis-report",
    metaTitle: "KPI Dashboard | Vessel Performance &  Monitoring",
    metaDescription:
      "View vessel performance KPIs and IMO DCS data including annual fuel consumption, distance traveled, hours underway, and regulatory compliance insights in one dashboard."
  },
  KPITechnicalAnalysisofcBreakdowns: {
    url: "/kpi/technical/analysis-of-breakdowns",
    metaTitle: "KPI Dashboard | Vessel Performance &  Monitoring",
    metaDescription:
      "View vessel performance KPIs and IMO DCS data including annual fuel consumption, distance traveled, hours underway, and regulatory compliance insights in one dashboard."
  },
  KPITechnicalRequisitionStatus: {
    url: "/kpi/technical/requisition-status",
    metaTitle: "KPI Dashboard | Vessel Performance &  Monitoring",
    metaDescription:
      "View vessel performance KPIs and IMO DCS data including annual fuel consumption, distance traveled, hours underway, and regulatory compliance insights in one dashboard."
  },
  KPICommercialPscInspection: {
    url: "/kpi/commercial/psc-inspection",
    metaTitle: "KPI Dashboard | Vessel Performance &  Monitoring",
    metaDescription:
      "View vessel performance KPIs and IMO DCS data including annual fuel consumption, distance traveled, hours underway, and regulatory compliance insights in one dashboard."
  },
  KPICommercialRightshipRating: {
    url: "/kpi/commercial/right-ship-rating",
    metaTitle: "KPI Dashboard | Vessel Performance &  Monitoring",
    metaDescription:
      "View vessel performance KPIs and IMO DCS data including annual fuel consumption, distance traveled, hours underway, and regulatory compliance insights in one dashboard."
  },
  KPICommercialCustomerSatisfaction: {
    url: "/kpi/commercial/customer-satisfaction",
    metaTitle: "KPI Dashboard | Vessel Performance &  Monitoring",
    metaDescription:
      "View vessel performance KPIs and IMO DCS data including annual fuel consumption, distance traveled, hours underway, and regulatory compliance insights in one dashboard."
  },
  KPICommercialBudget: {
    url: "/kpi/commercial/budget",
    metaTitle: "KPI Dashboard | Vessel Performance &  Monitoring",
    metaDescription:
      "View vessel performance KPIs and IMO DCS data including annual fuel consumption, distance traveled, hours underway, and regulatory compliance insights in one dashboard."
  },
  KPICommercialDamagesAndDelays: {
    url: "/kpi/commercial/damage-and-delays",
    metaTitle: "KPI Dashboard | Vessel Performance &  Monitoring",
    metaDescription:
      "View vessel performance KPIs and IMO DCS data including annual fuel consumption, distance traveled, hours underway, and regulatory compliance insights in one dashboard."
  },
  KPIVesselConditionLoadLineModule: {
    url: "/kpi/vessel-condition/load-line-module",
    metaTitle: "KPI Dashboard | Vessel Performance &  Monitoring",
    metaDescription:
      "View vessel performance KPIs and IMO DCS data including annual fuel consumption, distance traveled, hours underway, and regulatory compliance insights in one dashboard."
  },
  KPIVesselConditionVir: {
    url: "/kpi/vessel-condition/vir",
    metaTitle: "KPI Dashboard | Vessel Performance &  Monitoring",
    metaDescription:
      "View vessel performance KPIs and IMO DCS data including annual fuel consumption, distance traveled, hours underway, and regulatory compliance insights in one dashboard."
  },
  KPIVesselConditionHatchCover: {
    url: "/kpi/vessel-condition/hatch-cover",
    metaTitle: "KPI Dashboard | Vessel Performance &  Monitoring",
    metaDescription:
      "View vessel performance KPIs and IMO DCS data including annual fuel consumption, distance traveled, hours underway, and regulatory compliance insights in one dashboard."
  },
  KPIVesselConditionCargoGear: {
    url: "/kpi/vessel-condition/cargo-gear",
    metaTitle: "KPI Dashboard | Vessel Performance &  Monitoring",
    metaDescription:
      "View vessel performance KPIs and IMO DCS data including annual fuel consumption, distance traveled, hours underway, and regulatory compliance insights in one dashboard."
  },
  KPIVesselConditionDeckMaintenance: {
    url: "/kpi/vessel-condition/deck-maintenance-plan",
    metaTitle: "KPI Dashboard | Vessel Performance &  Monitoring",
    metaDescription:
      "View vessel performance KPIs and IMO DCS data including annual fuel consumption, distance traveled, hours underway, and regulatory compliance insights in one dashboard."
  },
  KPIVesselConditionParisUpdate: {
    url: "/kpi/vessel-condition/paris-update",
    metaTitle: "KPI Dashboard | Vessel Performance &  Monitoring",
    metaDescription:
      "View vessel performance KPIs and IMO DCS data including annual fuel consumption, distance traveled, hours underway, and regulatory compliance insights in one dashboard."
  },
  KPISafetyEnvMarpol: {
    url: "/kpi/safety-env/marpol",
    metaTitle: "KPI Dashboard | Vessel Performance &  Monitoring",
    metaDescription:
      "View vessel performance KPIs and IMO DCS data including annual fuel consumption, distance traveled, hours underway, and regulatory compliance insights in one dashboard."
  },
  KPISafetyEnvBilgeGeneration: {
    url: "/kpi/safety-env/bilge-generation",
    metaTitle: "KPI Dashboard | Vessel Performance &  Monitoring",
    metaDescription:
      "View vessel performance KPIs and IMO DCS data including annual fuel consumption, distance traveled, hours underway, and regulatory compliance insights in one dashboard."
  },
  KPISafetyEnvLtiNearMisses: {
    url: "/kpi/safety-env/lti-near-misses",
    metaTitle: "KPI Dashboard | Vessel Performance &  Monitoring",
    metaDescription:
      "View vessel performance KPIs and IMO DCS data including annual fuel consumption, distance traveled, hours underway, and regulatory compliance insights in one dashboard."
  },
  KPIDataBase: {
    url: "/kpi/data-base",
    metaTitle: "KPI Dashboard | Vessel Performance &  Monitoring",
    metaDescription:
      "View vessel performance KPIs and IMO DCS data including annual fuel consumption, distance traveled, hours underway, and regulatory compliance insights in one dashboard."
  },
  KPISetup: {
    url: "/kpi/setup",
    metaTitle: "KPI Indicator Setup | Scoring & Weightage",
    metaDescription:
      "View KPI indicator definitions, weightage, and how YES / NO responses affect monthly module scores."
  },

};




const keys = {
  userDetails: 'vi_ud.iship.com',
  userToken: 'vi_tk.iship.com',
  authSession: 'vi_as.iship.com',
  userModule: 'vi_um.iship.com',
  selectedVessel: 'vi_sv.iship.com'


}
export default { keys, commoncomponent, nonAuthedcomponent, Authedcomponent }
